import { Box } from 'grommet'
import Image from 'next/image'
import styled, { css } from 'styled-components'

import Hexagon from '@public/images/hexagon.svg'

const MAX_WIDTH_CONTAINER = 996

export const HexagonStyled = styled(Hexagon)`
  position: absolute;

  path {
    stroke: ${({ theme }) => theme.newColors.accent};
    stroke-width: 4px;
  }

  ${({ theme }) => theme.below.laptopM`
    display: none;
  `}
`

export const LeftHexagon = styled(HexagonStyled)`
  left: -${({ theme }) => theme.newSpaces.xl3}px;
  top: 50%;
  transform: scale(4) rotate(80deg);

  path {
    opacity: 0.1;
    stroke: ${({ theme }) => theme.newColors.accent};
    stroke-width: 4px;
  }
`

export const BottomRightHexagon = styled(Image)`
  bottom: 280px;
  position: absolute;
  right: 0px;
  width: 200px;

  ${({ theme }) => theme.below.laptopM`
    display: none;
  `}
`

export const Wrapper = styled(Box)`
  margin: 0 auto;
  max-width: ${MAX_WIDTH_CONTAINER}px;
  width: 100%;
`

export const stepTitleStyles = css`
  ${({ theme }) => theme.getTypography('desktop', 'title', 'title3')}

  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  text-transform: unset;

  ${({ theme }) => theme.below.mobileL`
    ${theme.getTypography('mobile', 'title', 'title3')}
  `}
`

export const ProcessContainer = styled(Box)`
  position: relative;

  ${({ theme }) => theme.below.laptopL`
    padding: 0px ${theme.newSpaces.md}px;
  `}
`
